import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";

export const getEmailAccount = async (organization_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/email-register/`;
      const response = await axios.get(endpoint, { headers });
      console.log('Response from getEmailAccount:', response);
      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response?.data };
      } else {
        console.error("Data retrieval failed:", response, response.data);
        return { success: false, data: response?.data };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error occurred while fetching emails:", error);
    return { success: false, data: undefined };
  }
};

export const getEmails = async (organization_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/email/`;
      const response = await axios.get(endpoint, { headers });
      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response?.data };
      } else {
        console.error("Data retrieval failed:", response, response.data);
        return { success: false, data: response?.data };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error occurred while fetching emails:", error);
    return { success: false, data: undefined };
  }
};

export const getEmailById = async (organization_id: any, email_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/email/${email_id}`;
      const response = await axios.get(endpoint, { headers });
      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response?.data };
      } else {
        console.error("Data retrieval failed:", response, response.data);
        return { success: false, data: response?.data };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error occurred while fetching email:", error);
    return { success: false, data: undefined };
  }
};

export const sendEmail = async (organization_id: any, payload: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = {
        Authorization: header_token,
        "Content-Type": "application/json",
      };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/emails/send`;
      const response = await axios.post(endpoint, payload, { headers });
      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response?.data };
      } else {
        console.error("Email send failed:", response, response.data);
        return { success: false, data: response?.data };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error occurred while sending email:", error);
    return { success: false, data: undefined };
  }
};

export const sendInitCodeFromGoogleToBackend = async (organization_id: any, payload: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = {
        Authorization: header_token,
        "Content-Type": "application/json",
      };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/email-register/`;
      const response = await axios.post(endpoint, payload, { headers });
      console.log('Payload sent to backend:', payload);
      console.log('Response on send init code returned from backend:', response);
      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response?.data };
      } else {
        console.error("Code sending failed:", response, response.data);
        return { success: false, data: response?.data };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error occurred while sending email:", error);
    return { success: false, data: undefined };
  }
};

export const deleteEmail = async (organization_id: any, email_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/emails/${email_id}`;
      const response = await axios.delete(endpoint, { headers });
      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response?.data };
      } else {
        console.error("Email delete failed:", response, response.data);
        return { success: false, data: response?.data };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error occurred while deleting email:", error);
    return { success: false, data: undefined };
  }
};
